import { useInterfaceLocales } from '@shared/hooks/displayNames';
import { useFormatMessage } from '@shared/hooks/intl';
import Select from '@ui/formElements/Select';
import { useMemo } from 'react';

type Props = {
  value: string;
  onChange: (value: string) => void;
};
const TranslationLanguageMenu: FC<Props> = ({ value, onChange }) => {
  const t = useFormatMessage();
  const locales = useInterfaceLocales();
  const options = useMemo(
    () =>
      locales
        // Primary language of the document is English, so no need to translate
        .filter(({ code }) => code !== 'en')
        .map(({ code: value, name: label }) => ({ value, label, disabled: false }))
        .concat([
          { value: '', label: t('google_translate.select_language_label'), disabled: true },
        ]),
    [locales, t],
  );

  return (
    <Select
      name="select_language"
      value={value}
      placeholder={t('google_translate.select_language_label')}
      onChange={(e) => onChange(e.target.value)}
      options={options}
      fullWidth={true}
    />
  );
};

export default TranslationLanguageMenu;
